/* PAMÉ — smooth open/close for product page accordions (.product__accordion > details).
   Native <details> snaps on close; this animates height in both directions cleanly. */
(function () {
  var DUR = 320; // ms — keep in sync with CSS transition
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setup(details) {
    if (details.__pameAcc) return;
    details.__pameAcc = true;
    var summary = details.querySelector('summary');
    var content = details.querySelector('.accordion__content');
    if (!summary || !content) return;

    summary.addEventListener('click', function (e) {
      if (reduce) return; // let native behaviour handle it
      e.preventDefault();
      if (details.__animating) return;
      if (details.open) closeAcc(); else openAcc();
    });

    function openAcc() {
      details.__animating = true;
      details.open = true;                 // reveal content so we can measure it
      content.style.height = '0px';
      content.style.overflow = 'hidden';
      // next frame: animate to full height
      requestAnimationFrame(function () {
        var h = content.scrollHeight;
        content.style.transition = 'height ' + DUR + 'ms cubic-bezier(0.22,0.61,0.36,1)';
        content.style.height = h + 'px';
      });
      onEnd(function () {
        content.style.height = 'auto';
        content.style.transition = '';
        content.style.overflow = '';
        details.__animating = false;
      });
    }

    function closeAcc() {
      details.__animating = true;
      content.style.overflow = 'hidden';
      content.style.height = content.scrollHeight + 'px';
      requestAnimationFrame(function () {
        content.style.transition = 'height ' + DUR + 'ms cubic-bezier(0.22,0.61,0.36,1)';
        content.style.height = '0px';
      });
      onEnd(function () {
        details.open = false;              // collapse only after the animation
        content.style.height = '';
        content.style.transition = '';
        content.style.overflow = '';
        details.__animating = false;
      });
    }

    function onEnd(fn) {
      var done = false;
      function handler(ev) {
        if (ev && ev.propertyName && ev.propertyName !== 'height') return;
        if (done) return; done = true;
        content.removeEventListener('transitionend', handler);
        fn();
      }
      content.addEventListener('transitionend', handler);
      setTimeout(handler, DUR + 80); // fallback if transitionend doesn't fire
    }
  }

  function init(root) {
    (root || document).querySelectorAll('.product__accordion > details').forEach(setup);
  }

  document.addEventListener('DOMContentLoaded', function () { init(); });
  init();
  // re-init inside the theme editor when a section reloads
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
